import { HttpErrorResponse, HttpRequest } from '@angular/common/http';
import * as Sentry from '@sentry/capacitor';

export const logErrorToSentry = (error: Error | HttpErrorResponse, request: HttpRequest<unknown>) => {
  if (error instanceof HttpErrorResponse) {
    console.error('Logging HTTP error to Sentry', request.url, request.method, request.body, error.error, error.status, error.statusText);
    Sentry.captureException(error, {
      extra: {
        url: request.url,
        method: request.method,
        requestBody: request.body,
        responseBody: error.error,
        status: error.status,
        statusText: error.statusText,
      },
      tags: {
        type: 'api_error',
        endpoint: request.url,
        errorStatus: error.status,
      },
    });
  } else {
    console.error('Logging generic error to Sentry', request.url, request.method, request.body, error.message, error.stack);
    Sentry.captureException(error, {
      extra: {
        url: request.url,
        method: request.method,
        requestBody: request.body,
        errorMessage: error.message,
      },
      tags: {
        type: 'application_error',
        endpoint: request.url,
      },
    });
  }
};

export const logMessageToSentry = (message: string, request: HttpRequest<unknown>, extra: Record<string, unknown> = {}) => {
  console.log('Logging message to Sentry', message, request, extra);
  Sentry.captureMessage(message, {
    extra: {
      url: request.url,
      method: request.method,
      requestBody: request.body,
    },
  });
};
